import React, { lazy } from 'react';
import RouterRoutes from 'Helpers/routes/router-routes';
import { registry } from 'Store';
import { GetDashboardAndRouteToNextStep } from 'Components/dashboard/ducks/actions';

const CarvanaProtectionComponent = lazy(() =>
  import(
    /* webpackChunkName: "carvana-purchase-ancillary-products" */ '@carvana/purchase-ancillary-products'
  )
);

export const CarvanaProtectionRoute = props => {
  return (
    <RouterRoutes
      {...props}
      lazyLoadingText="We're preparing all the little extras you can add to your vehicle!"
      isLoadingText="We're preparing all the little extras you can add to your vehicle!"
    >
      <CarvanaProtectionComponent
        registry={registry}
        dashboardActions={{
          GetDashboardAndRouteToNextStep
        }}
      />
    </RouterRoutes>
  );
};
